import { render, staticRenderFns } from "./plan-page.vue?vue&type=template&id=30c09896&scoped=true"
import script from "./plan-page.vue?vue&type=script&lang=js"
export * from "./plan-page.vue?vue&type=script&lang=js"
import style0 from "./plan-page.vue?vue&type=style&index=0&id=30c09896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c09896",
  null
  
)

export default component.exports